import { legacyPlugins } from "/app/node_modules/.pnpm/@unhead+vue@3.4.2_@oxc-project+types@0.152.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_67eab3e474e308cf43ed4280b5e7f8b9/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}